import { render, staticRenderFns } from "./VehicleSelection.vue?vue&type=template&id=fb271d10&scoped=true"
import script from "./VehicleSelection.vue?vue&type=script&lang=js"
export * from "./VehicleSelection.vue?vue&type=script&lang=js"
import style0 from "./VehicleSelection.vue?vue&type=style&index=0&id=fb271d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb271d10",
  null
  
)

export default component.exports